var map = {
	"./CriarEvento.vue": [
		"78f6",
		"chunk-94e3b956"
	],
	"./Cronometro.vue": [
		"3af6",
		"chunk-470e5883"
	],
	"./CurrentFight.vue": [
		"f430",
		"chunk-096b7d3d"
	],
	"./EditarEvento.vue": [
		"eaf0",
		"chunk-621431d7"
	],
	"./EventoDetalhe.vue": [
		"f183",
		"chunk-1f7e3573"
	],
	"./Eventos.vue": [
		"cc53",
		"chunk-0cda25c0"
	],
	"./Fights.vue": [
		"ef81",
		"chunk-cf7a8c9a"
	],
	"./Groups.vue": [
		"3004",
		"chunk-1e17ea21"
	],
	"./Home.vue": [
		"4155",
		"chunk-ac11ebaa"
	],
	"./Inscricoes.vue": [
		"7f31",
		"chunk-2387ff1c"
	],
	"./InspectRobot.vue": [
		"630b",
		"chunk-181350da"
	],
	"./Keys.vue": [
		"f049",
		"chunk-732ff0c9"
	],
	"./MinhaEquipe.vue": [
		"c361",
		"chunk-3c584ece"
	],
	"./Regras.vue": [
		"db9c",
		"chunk-c23ceba6"
	],
	"./Robots.vue": [
		"3732",
		"chunk-6c75e1d0"
	],
	"./Roleta.vue": [
		"d550",
		"chunk-e06fa668"
	],
	"./SignIn.vue": [
		"3f57",
		"chunk-d3fd6db2"
	],
	"./SignUp.vue": [
		"1e1f",
		"chunk-8513968e"
	],
	"./UserProfile.vue": [
		"94e2",
		"chunk-c2576984"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9665";
module.exports = webpackAsyncContext;